<template>
  <ConfigErrorBoundary>
    <FileConverter :config="converterConfig" @batch-created="handleBatchCreated" @job-completed="handleJobCompleted" @batch-cleared="handleBatchCleared" @error="handleError" @credits-updated="handleCreditsUpdated" />
  </ConfigErrorBoundary>
</template>
<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';
const converterConfig = parseAndValidateConverterConfig('raf-to-webp-converter', 'Fujifilm RAF → WebP');
function handleBatchCreated(batchId: string) { console.log('[RAF to WebP] Batch created:', batchId); }
function handleJobCompleted(jobId: string) { console.log('[RAF to WebP] Job completed:', jobId); }
function handleBatchCleared() { console.log('[RAF to WebP] Batch cleared'); }
function handleError(error: Error) { console.error('[RAF to WebP] Error:', error); }
function handleCreditsUpdated(credits: number) { console.log('[RAF to WebP] Credits updated:', credits); }
</script>
